import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'sortByLastname'
})
export class SortByLastnamePipe implements PipeTransform{

    transform(array: Array<any>): Array<string> {
        array.sort((a: any, b: any) => {
          if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
            return -1;
          } else if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
            return 1;
          } else {
            return 0;
          }
        });
        return array;
      }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Pipes/sortByLastname.pipe.ts